import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CAConstant } from "../../shared/constant";
import { catchError, map } from "rxjs/operators";
import { jwtDecode } from "jwt-decode";
import { ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  _isLoggedIn = true;
  userID: string;
  token = "";
  reloadRoute = new ReplaySubject<boolean>(1);
  constructor(private http: HttpClient) {}

  isLoggedIn(): boolean {
    const token: string = localStorage.getItem(CAConstant.TOKEN);
    if (token && token !== "") {
      this._isLoggedIn = true;
    } else {
      this._isLoggedIn = false;
    }
    return this._isLoggedIn;
  }

  getToken(): string {
    return localStorage.getItem(CAConstant.TOKEN);
  }

  setToken(token: string) {
    localStorage.setItem(CAConstant.TOKEN, token);
  }

  setUserID(userID: string) {
    this.userID = userID;
    localStorage.setItem(CAConstant.USER_ID, userID);
  }

  setIdType(idType: string) {
    localStorage.setItem(CAConstant.ID_TYPE, idType);
  }

  setUxfToken(uxfToken: string) {
    try {
      let tmp = decodeURIComponent(uxfToken);
      localStorage.setItem(CAConstant.UXF_TOKEN, tmp);
    } catch (e) {
      console.error(e);
    }
  }

  getUxfToken() {
    return localStorage.getItem(CAConstant.UXF_TOKEN);
  }

  getUxfUserID() {
    return localStorage.getItem(CAConstant.USER_ID);
  }

  getUserID(): string {
    let userIDLogin: string = this.getUserName(); //username maybe has suffix @maxis.com.my --> userId must be remove this suffix
    if (userIDLogin) {
      const index = userIDLogin.lastIndexOf("@");
      if (index > 0) {
        userIDLogin = userIDLogin.substring(0, index);
      }
    }
    this.userID = userIDLogin;
    return userIDLogin;
  }

  getUserName() {
    return localStorage.getItem(CAConstant.USER_DISPLAY_NAME);
  }

  setUserName(userName: string) {
    localStorage.setItem(CAConstant.USER_DISPLAY_NAME, userName);
  }

  login(): Promise<any> {
    return this.http
      .get(`login`)
      .pipe(
        map((response) => {
          return true;
        }),
        catchError((error) => {
          return Promise.reject(false);
        })
      )
      .toPromise();
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwtDecode(token);
    if (decoded.exp === undefined) return null;
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) token = this.getToken();
    if (!token) return true;
    const date = this.getTokenExpirationDate(token);
    if (date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }

  getProjectId(): string {
    return localStorage.getItem(CAConstant.PROJECT_ID);
  }

  setProjectId(projectId) {
    localStorage.setItem(CAConstant.PROJECT_ID, projectId);
  }

  logout() {
    localStorage.removeItem(CAConstant.PROJECT_ID);
    localStorage.removeItem(CAConstant.USER_DISPLAY_NAME);
    localStorage.removeItem(CAConstant.TOKEN);
  }

  clearAll() {
    localStorage.clear();
  }
}
